import _defaultApi from '@/utils/request';

const defaultApi = _defaultApi;

export default {
  /* -------------------- WzuFcm -------------------- */
  LoadFcmView(params) {
    return defaultApi({
      method: 'get',
      url: 'wzuFcm/LoadFcmView',
      params,
    });
  },
  /* --- 推播授權管理 --- */
  LoadFcmAuthEditView(params) {
    return defaultApi({
      method: 'get',
      url: 'wzuFcm/LoadFcmAuthEditView',
      params,
    });
  },
  SaveFcmAuthEditView(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/SaveFcmAuthEditView ',
      data,
    });
  },
  DeleteFcmAuthData(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/DeleteFcmAuthData',
      data,
    });
  },

  /* --- 推播群組管理 --- */
  LoadFcmGroupEditView(params) {
    return defaultApi({
      method: 'get',
      url: 'wzuFcm/LoadFcmGroupEditView',
      params,
    });
  },
  SaveFcmGroupEditView(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/SaveFcmGroupEditView ',
      data,
    });
  },
  DeleteFcmGroupData(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/DeleteFcmGroupData',
      data,
    });
  },

  /* --- 推播群組成員管理 --- */
  LoadFcmGroupUserEditView(params) {
    return defaultApi({
      method: 'get',
      url: 'wzuFcm/LoadFcmGroupUserEditView',
      params,
    });
  },
  SaveFcmGroupUserEditView(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/SaveFcmGroupUserEditView ',
      data,
    });
  },
  DeleteFcmGroupUserData(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/DeleteFcmGroupUserData',
      data,
    });
  },

  /* --- 推播訊息管理 --- */
  LoadFcmMessageEditView(params) {
    return defaultApi({
      method: 'get',
      url: 'wzuFcm/LoadFcmMessageEditView',
      params,
    });
  },
  SaveFcmMessageEditView(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/SaveFcmMessageEditView ',
      data,
    });
  },
  DeleteFcmMessageData(data) {
    return defaultApi({
      method: 'post',
      url: 'wzuFcm/DeleteFcmMessageData',
      data,
    });
  },
};
